import styled from 'styled-components';
import {Row, RowW50Styles, Column} from '../../common/Layouts/Layouts';

export const DetailCardLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  max-width: 120rem;
  margin: 0 auto;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  margin-top:${props.theme.spacing.xlarge};
  padding

`,
);

export const DetailCardLoaderGalleryBlock = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:50%;
`,
);

export const DetailCardLoaderPricingBlock = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:50%;
`,
);

export const HotelGalleryBlockDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  margin-right:${props.theme.spacing.xlarge};
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.base};
  width:590px;
  height:31.9rem;


`,
);

export const TravellerGalleryBlockDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction:column;
  margin-right:${props.theme.spacing.base};

`,
);

export const TravellerGalleryInnerDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  margin-bottom:${props.theme.spacing.base};
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.base};
  width:18.4rem;
  height:10rem;


`,
);

export const ReviewRightComponentInnerWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  border-radius:${props.theme.misc.borderRadius.large};

`,
);

export const GuestLikeHeaderWrapDiv = styled.div(
  props => `

  width:100%;
  display:flex;
  flex-wrap: wrap;
  padding:${props.theme.spacing.small};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};


`,
);

export const GuestLikeLoaderDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:17rem;
  height:2.1rem;


`,
);

export const AmmenitiesTypeNewDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:16rem;
  height:1.7rem;
  margin-bottom:${props.theme.spacing.small};


`,
);

export const AmmenitiesTypeOuterDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding:${props.theme.spacing.base};

`,
);

export const RightBlockAmenitiesDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:22.3rem;
  height:2.3rem;

`,
);

export const RightBlockSecondDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    border-radius:${props.theme.misc.borderRadius.large};
    width:50%;
  `,
);

export const GuestLikeOuterWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  margin-right:${props.theme.spacing.large};
`,
);

export const GuestLikeInnerWrapDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:28.5rem;
    border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
    border-radius:${props.theme.misc.borderRadius.large};

  `,
);

export const GuestLikeHeaderLoaderWrapDiv = styled.div(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-top:${props.theme.spacing.base};
    padding-bottom:${props.theme.spacing.base};
    padding-left:${props.theme.spacing.large};
    padding-right:${props.theme.spacing.large};
    border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};

  `,
);

export const GuestLikeHeaderLoaderSpan = styled.span(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius:${props.theme.misc.borderRadius.small};
    width:22.3rem;
    height:2.3rem;

    `,
);

export const GuestLikeHeaderLoaderOneSpan = styled.span(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius:${props.theme.misc.borderRadius.small};
    margin-right:${props.theme.spacing.base};
    margin-bottom:${props.theme.spacing.large};
    width:15.4rem;
    height:3.2rem;

    `,
);

export const GuestLikeHeaderLoaderTwoSpan = styled.span(
  props => `

    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    background-color:${props.theme.colors.goBrandBlue.medium};
    border-radius:${props.theme.misc.borderRadius.small};
    margin-right:${props.theme.spacing.base};
    margin-bottom:${props.theme.spacing.large};
    width:8.5rem;
    height:3.2rem;

      `,
);

export const SignUpOuterWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: column;
  width:30rem;

  `,
);

export const SignUpOuterFirstWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  border-radius:${props.theme.misc.borderRadius.large};
  padding:${props.theme.spacing.large};
  justify-content: space-between;
  margin-bottom:${props.theme.spacing.large};

  `,
);

export const SignUpOuterFirstWrapimageDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:3.6rem;
  height:3.6rem;
  `,
);

export const SignUpOuterFirstWraptextDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction:column;
  `,
);

export const SignUpOuterFirstWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:21.6rem;
  height:1.2rem;
  margin-bottom:${props.theme.spacing.small};
  `,
);

export const SignUpOuterSecondWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:21.6rem;
  height:1.2rem;
  margin-top:${props.theme.spacing.small};
  `,
);

export const SignUpOuterSecondWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  border-radius:${props.theme.misc.borderRadius.large};
  padding:${props.theme.spacing.large};
  margin-bottom:${props.theme.spacing.large};

  `,
);

export const GiftCardWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  margin-top:${props.theme.spacing.small};
  width:26rem;
  height:1.6rem;
  `,
);

export const SignUpOuterThirdWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  border-radius:${props.theme.misc.borderRadius.large};
  padding:${props.theme.spacing.large};
  `,
);

export const PricingWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  border-radius:${props.theme.misc.borderRadius.large};
  padding:${props.theme.spacing.large};
  `,
);

export const PricingTextWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  width:100%;

  `,
);

export const PricingTextLeftWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction:column;

  `,
);

export const PricingTextLeftOneWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:10.5rem;
  height:1.35rem;

  `,
);

export const PricingTextLeftSecondWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:10.5rem;
  height:1.35rem;

  `,
);

export const PricingTextRightWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction:column;
  padding-top:${props.theme.spacing.small};

  `,
);

export const PricingTextRightTextWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:10.9rem;
  height:1.8rem;

  `,
);

export const PayAmountWrapDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  margin-top:${props.theme.spacing.base};
  `,
);

export const PayAmountWrapInnerDiv = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:25.5rem;
  height:4.5rem;

  `,
);
